module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3mysF"))).then(() => parcelRequire('d7OHU'));